import useSWR from "swr";
import fetcher from "../../lib/fetcher";

import AdminLayout from "../../components/Layout/AdminLayout";
import FormularForm from "../../components/Forms/FormularForm";
import Spinner from "../../components/Spinner";
import Error from "../../components/Error";

export default function FormulareEdit(props) {
  const { data, error } = useSWR(
    `/api/forms/${props.match.params.id}`,
    fetcher
  );

  if (error) return <Error error={error} />;
  if (!data) return <Spinner />;

  const defaultValues = {
    name: data.data.name,
    description: data.data.description,
    files: data.data.files,
  };

  return (
    <AdminLayout title="Formulare">
      <FormularForm {...props} defaultValues={defaultValues} />
    </AdminLayout>
  );
}
